// src/data/triggersData.ts
import { TriggerData } from './types';

export const triggers: TriggerData[] = [
  { 
    name: "Stress and anxiety",
    category: "lifestyle",
    description: "Emotional stress is one of the most commonly reported triggers"
  },
  { 
    name: "Hormonal changes",
    category: "hormonal",
    description: "Many women report attacks around menstruation or other hormonal fluctuations"
  },
  { 
    name: "Sleep disturbances",
    category: "lifestyle",
    description: "Both too much and too little sleep can trigger attacks"
  },
  { 
    name: "Certain foods and drinks",
    category: "dietary",
    description: "Common culprits include aged cheeses, processed foods, and alcohol"
  },
  { 
    name: "Weather changes",
    category: "environmental",
    description: "Barometric pressure changes, storms, and temperature shifts"
  }
];

export const triggerNames: string[] = triggers.map(t => t.name);